import React from 'react';
import ReactCardFlip from 'react-card-flip';
import "../index.css";

//MUI
import { Box, Typography } from "@mui/material";
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { CardActionArea } from '@mui/material';


// Images
import secA from '../assets/images/cardImages/disclosures.jpg';
import secB from '../assets/images/cardImages/policies.jpg';
import P1 from '../assets/images/cardImages/ethics.jpg';
import P2 from '../assets/images/cardImages/sustainable_product.jpg';
import P3 from '../assets/images/cardImages/wellbeing.jpg';
import P4 from '../assets/images/cardImages/stakeholder_interest.jpg';
import P5 from '../assets/images/cardImages/human_rights.jpg';
import P6 from '../assets/images/cardImages/environment.jpg';
import P7 from '../assets/images/cardImages/regulatory.jpg';
import P8 from '../assets/images/cardImages/nanhiKaliCard.jpg';
import P9 from '../assets/images/cardImages/it.jpg';
import assurance from '../assets/images/cardImages/assurance.jpg';


const Sections = () => {

    const [flip1, setFlip1] = React.useState(false);
    const [flip2, setFlip2] = React.useState(false);
    const [flip3, setFlip3] = React.useState(false);
    const [flip4, setFlip4] = React.useState(false);
    const [flip5, setFlip5] = React.useState(false);
    const [flip6, setFlip6] = React.useState(false);
    const [flip7, setFlip7] = React.useState(false);
    const [flip8, setFlip8] = React.useState(false);
    const [flip9, setFlip9] = React.useState(false);

    return (
        <Box >
            <Grid container spacing={3}>
                <Grid item xs={12} md={6} lg={4}>
                    <Card sx={{ minHeight: 320, backgroundColor: "#231f20", backgroundSize: "cover" }} raised={true} >
                        <CardActionArea href='/sectiona'>
                            <CardMedia
                                sx={{ height: 160 }}
                                image={secA}
                                title="sectiona"
                            />
                            <CardContent sx={{ height: 160 }}>
                                <Typography gutterBottom variant="h5" component="div" sx={{ color: "white" }}>
                                    Section A
                                </Typography>
                                <Typography variant="body1" color="text.secondary" sx={{ color: "white" }}>
                                    General Disclosures

                                </Typography>
                            </CardContent>

                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                    <Card sx={{ minHeight: 320, backgroundColor: "#231f20", backgroundSize: "cover" }} raised={true}>
                        <CardActionArea href='/sectionb'>
                            <CardMedia
                                sx={{ height: 160 }}
                                image={secB}
                                title="sectionb"
                            />
                            <CardContent sx={{ height: 160 }}>
                                <Typography gutterBottom variant="h5" component="div" sx={{ color: "white" }}>
                                    Section B
                                </Typography>
                                <Typography variant="body1" color="text.secondary" sx={{ color: "white" }}>
                                    Policy and Management Processes
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={12} md={6} lg={4} onMouseOver={() => { setFlip1(true) }} onMouseOut={() => { setFlip1(false) }}>
                    <ReactCardFlip isFlipped={flip1} flipDirection="horizontal">
                        <Card sx={{ minHeight: 320, backgroundColor: "#231f20", backgroundSize: "cover" }} raised={true} >
                            <CardActionArea href='/sectionc1'>
                                <CardMedia
                                    sx={{ height: 160 }}
                                    image={P1}
                                    title="sectionc1"
                                />
                                <CardContent sx={{ height: 160 }}>
                                    <Typography gutterBottom variant="h5" component="div" sx={{ color: "white" }}>
                                        Principle 1
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary" sx={{ color: "white" }}>
                                        Integrity and Ethics
                                    </Typography>
                                </CardContent>

                            </CardActionArea>
                        </Card>

                        <Card sx={{ minHeight: 320, backgroundColor: "#231f20", backgroundSize: "cover" }}>
                            <CardActionArea href='/sectionc1' sx={{ height: 304 }}>
                                <CardContent sx={{ margin: "16px" }}>
                                    <Typography variant="h5" component="div" sx={{ mb: 1.5, color: "white" }}>
                                        Principle 1
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: "white", textAlign: "justify" }}>
                                        Businesses should conduct and govern themselves with integrity, and in a manner that is ethical, transparent, and accountable.
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </ReactCardFlip>
                </Grid>
                <Grid item xs={12} md={6} lg={4} onMouseOver={() => { setFlip2(true) }} onMouseOut={() => { setFlip2(false) }}>
                    <ReactCardFlip isFlipped={flip2} flipDirection="horizontal" >
                        <Card sx={{ minHeight: 320, backgroundColor: "#231f20", backgroundSize: "cover" }} raised={true} >
                            <CardActionArea href='/sectionc2'>
                                <CardMedia
                                    sx={{ height: 160 }}
                                    image={P2}
                                    title="sectionc2"
                                />
                                <CardContent sx={{ height: 160 }}>
                                    <Typography gutterBottom variant="h5" component="div" sx={{ color: "white" }}>
                                        Principle 2
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary" sx={{ color: "white" }}>
                                        Sustainable Product
                                    </Typography>
                                </CardContent>

                            </CardActionArea>
                        </Card>

                        <Card sx={{ minHeight: 320, backgroundColor: "#231f20", backgroundSize: "cover" }}>
                            <CardActionArea href='/sectionc2' sx={{ height: 304 }}>
                                <CardContent sx={{ margin: "16px" }}>
                                    <Typography variant="h5" component="div" sx={{ mb: 1.5, color: "white" }}>
                                        Principle 2
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: "white", textAlign: "justify" }}>
                                        Businesses should provide goods and services in a manner that is sustainable and safe.
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </ReactCardFlip>
                </Grid>
                <Grid item xs={12} md={6} lg={4} onMouseOver={() => { setFlip3(true) }} onMouseOut={() => { setFlip3(false) }}>
                    <ReactCardFlip isFlipped={flip3} flipDirection="horizontal">
                        <Card sx={{ minHeight: 320, backgroundColor: "#231f20", backgroundSize: "cover" }} raised={true} >
                            <CardActionArea href='/sectionc3'>
                                <CardMedia
                                    sx={{ height: 160 }}
                                    image={P3}
                                    title="sectionc3"
                                />
                                <CardContent sx={{ height: 160 }}>
                                    <Typography gutterBottom variant="h5" component="div" sx={{ color: "white" }}>
                                        Principle 3
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary" sx={{ color: "white" }}>
                                        Employee Wellbeing
                                    </Typography>
                                </CardContent>

                            </CardActionArea>
                        </Card>

                        <Card sx={{ minHeight: 320, backgroundColor: "#231f20", backgroundSize: "cover" }}>
                            <CardActionArea href='/sectionc3' sx={{ height: 304 }}>
                                <CardContent sx={{ margin: "16px" }}>
                                    <Typography variant="h5" component="div" sx={{ mb: 1.5, color: "white" }}>
                                        Principle 3
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: "white", textAlign: "justify" }}>
                                        Businesses should
                                        respect and promote
                                        the well-being of all
                                        employees, including
                                        those in their value chains.
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </ReactCardFlip>
                </Grid>
                <Grid item xs={12} md={6} lg={4} onMouseOver={() => { setFlip4(true) }} onMouseOut={() => { setFlip4(false) }}>
                    <ReactCardFlip isFlipped={flip4} flipDirection="horizontal">
                        <Card sx={{ minHeight: 320, backgroundColor: "#231f20", backgroundSize: "cover" }} raised={true} >
                            <CardActionArea href='/sectionc4'>
                                <CardMedia
                                    sx={{ height: 160 }}
                                    image={P4}
                                    title="sectionc4"
                                />
                                <CardContent sx={{ height: 160 }}>
                                    <Typography gutterBottom variant="h5" component="div" sx={{ color: "white" }}>
                                        Principle 4
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary" sx={{ color: "white" }}>
                                        Stakeholder Interest
                                    </Typography>
                                </CardContent>

                            </CardActionArea>
                        </Card>

                        <Card sx={{ minHeight: 320, backgroundColor: "#231f20", backgroundSize: "cover" }}>
                            <CardActionArea href='/sectionc4' sx={{ height: 304 }}>
                                <CardContent sx={{ margin: "16px" }}>
                                    <Typography variant="h5" component="div" sx={{ mb: 1.5, color: "white" }}>
                                        Principle 4
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: "white", textAlign: "justify" }}>
                                        Businesses should
                                        respect the interests of
                                        and be responsive to all its
                                        stakeholders.
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </ReactCardFlip>
                </Grid>
                <Grid item xs={12} md={6} lg={4} onMouseOver={() => { setFlip5(true) }} onMouseOut={() => { setFlip5(false) }}>
                    <ReactCardFlip isFlipped={flip5} flipDirection="horizontal">
                        <Card sx={{ minHeight: 320, backgroundColor: "#231f20", backgroundSize: "cover" }} raised={true} >
                            <CardActionArea href='/sectionc5'>
                                <CardMedia
                                    sx={{ height: 160 }}
                                    image={P5}
                                    title="sectionc5"
                                />
                                <CardContent sx={{ height: 160 }}>
                                    <Typography gutterBottom variant="h5" component="div" sx={{ color: "white" }}>
                                        Principle 5
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary" sx={{ color: "white" }}>
                                        Human Rights
                                    </Typography>
                                </CardContent>

                            </CardActionArea>
                        </Card>

                        <Card sx={{ minHeight: 320, backgroundColor: "#231f20", backgroundSize: "cover" }}>
                            <CardActionArea href='/sectionc5' sx={{ height: 304 }}>
                                <CardContent sx={{ margin: "16px" }}>
                                    <Typography variant="h5" component="div" sx={{ mb: 1.5, color: "white" }}>
                                        Principle 5
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: "white", textAlign: "justify" }}>
                                        Businesses should
                                        respect and
                                        promote human
                                        rights.
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </ReactCardFlip>
                </Grid>
                <Grid item xs={12} md={6} lg={4} onMouseOver={() => { setFlip6(true) }} onMouseOut={() => { setFlip6(false) }}>
                    <ReactCardFlip isFlipped={flip6} flipDirection="horizontal">
                        <Card sx={{ minHeight: 320, backgroundColor: "#231f20", backgroundSize: "cover" }} raised={true} >
                            <CardActionArea href='/sectionc6'>
                                <CardMedia
                                    sx={{ height: 160 }}
                                    image={P6}
                                    title="sectionc6"
                                />
                                <CardContent sx={{ height: 160 }}>
                                    <Typography gutterBottom variant="h5" component="div" sx={{ color: "white" }}>
                                        Principle 6
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary" sx={{ color: "white" }}>
                                        Environment
                                    </Typography>
                                </CardContent>

                            </CardActionArea>
                        </Card>

                        <Card sx={{ minHeight: 320, backgroundColor: "#231f20", backgroundSize: "cover" }}>
                            <CardActionArea href='/sectionc6' sx={{ height: 304 }}>
                                <CardContent sx={{ margin: "16px" }}>
                                    <Typography variant="h5" component="div" sx={{ mb: 1.5, color: "white" }}>
                                        Principle 6
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: "white", textAlign: "justify" }}>
                                        Businesses should
                                        respect and make efforts
                                        to protect and restore the
                                        environment.
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </ReactCardFlip>
                </Grid>
                <Grid item xs={12} md={6} lg={4} onMouseOver={() => { setFlip7(true) }} onMouseOut={() => { setFlip7(false) }}>
                    <ReactCardFlip isFlipped={flip7} flipDirection="horizontal">
                        <Card sx={{ minHeight: 320, backgroundColor: "#231f20", backgroundSize: "cover" }} raised={true} >
                            <CardActionArea href='/sectionc7'>
                                <CardMedia
                                    sx={{ height: 160 }}
                                    image={P7}
                                    title="sectionc7"
                                />
                                <CardContent sx={{ height: 160 }}>
                                    <Typography gutterBottom variant="h5" component="div" sx={{ color: "white" }}>
                                        Principle 7
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary" sx={{ color: "white" }}>
                                        Regulatory Policy
                                    </Typography>
                                </CardContent>

                            </CardActionArea>
                        </Card>

                        <Card sx={{ minHeight: 320, backgroundColor: "#231f20", backgroundSize: "cover" }}>
                            <CardActionArea href='/sectionc7' sx={{ height: 304 }}>
                                <CardContent sx={{ margin: "16px" }}>
                                    <Typography variant="h5" component="div" sx={{ mb: 1.5, color: "white" }}>
                                        Principle 7
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: "white", textAlign: "justify" }}>
                                        Businesses, when engaging
                                        in influencing public and
                                        regulatory policy, should
                                        do so in a manner that is
                                        responsible and transparent.
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </ReactCardFlip>
                </Grid>
                <Grid item xs={12} md={6} lg={4} onMouseOver={() => { setFlip8(true) }} onMouseOut={() => { setFlip8(false) }}>
                    <ReactCardFlip isFlipped={flip8} flipDirection="horizontal">
                        <Card sx={{ minHeight: 320, backgroundColor: "#231f20", backgroundSize: "cover" }} raised={true} >
                            <CardActionArea href='/sectionc8'>
                                <CardMedia
                                    sx={{ height: 160 }}
                                    image={P8}
                                    title="sectionc8"
                                />
                                <CardContent sx={{ height: 160 }}>
                                    <Typography gutterBottom variant="h5" component="div" sx={{ color: "white" }}>
                                        Principle 8
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary" sx={{ color: "white" }}>
                                        Inclusive Growth
                                    </Typography>
                                </CardContent>

                            </CardActionArea>
                        </Card>

                        <Card sx={{ minHeight: 320, backgroundColor: "#231f20", backgroundSize: "cover" }}>
                            <CardActionArea href='/sectionc8' sx={{ height: 304 }}>
                                <CardContent sx={{ margin: "16px" }}>
                                    <Typography variant="h5" component="div" sx={{ mb: 1.5, color: "white" }}>
                                        Principle 8
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: "white", textAlign: "justify" }}>
                                        Businesses should promote
                                        inclusive growth and equitable
                                        development.
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </ReactCardFlip>
                </Grid>
                <Grid item xs={12} md={6} lg={4} onMouseOver={() => { setFlip9(true) }} onMouseOut={() => { setFlip9(false) }}>
                    <ReactCardFlip isFlipped={flip9} flipDirection="horizontal">
                        <Card sx={{ minHeight: 320, backgroundColor: "#231f20", backgroundSize: "cover" }} raised={true} >
                            <CardActionArea href='/sectionc9'>
                                <CardMedia
                                    sx={{ height: 160 }}
                                    image={P9}
                                    title="sectionc9"
                                />
                                <CardContent sx={{ height: 160 }}>
                                    <Typography gutterBottom variant="h5" component="div" sx={{ color: "white" }}>
                                        Principle 9
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary" sx={{ color: "white" }}>
                                        Consumer and IT
                                    </Typography>
                                </CardContent>

                            </CardActionArea>
                        </Card>

                        <Card sx={{ minHeight: 320, backgroundColor: "#231f20", backgroundSize: "cover" }}>
                            <CardActionArea href='/sectionc9' sx={{ height: 304 }}>
                                <CardContent sx={{ margin: "16px" }}>
                                    <Typography variant="h5" component="div" sx={{ mb: 1.5, color: "white" }}>
                                        Principle 9
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: "white", textAlign: "justify" }}>
                                        Businesses should
                                        engage with and provide
                                        value to their consumers
                                        in a responsible manner.
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </ReactCardFlip>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                    <Card sx={{ minHeight: 320, backgroundColor: "#231f20", backgroundSize: "cover" }} raised={true} >
                        <CardActionArea href='/assurance-report'>
                            <CardMedia
                                sx={{ height: 160 }}
                                image={assurance}
                                title="Assurance Report"
                            />
                            <CardContent sx={{ height: 160 }}>
                                <Typography gutterBottom variant="h5" component="div" sx={{ color: "white" }}>
                                    Assurance Report
                                </Typography>
                                <Typography variant="body1" color="text.secondary" sx={{ color: "white" }}>
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    )
}


export default Sections;